/**
 * Debug logger that only logs in development mode.
 * In production builds, these calls become no-ops.
 */
export const logger = {
  debug: (...args: Array<unknown>) => {
    if (import.meta.env.DEV) {
      console.debug(...args)
    }
  },
  info: (...args: Array<unknown>) => {
    if (import.meta.env.DEV) {
      console.info(...args)
    }
  },
  warn: (...args: Array<unknown>) => {
    if (import.meta.env.DEV) {
      console.warn(...args)
    }
  },
  error: (...args: Array<unknown>) => {
    // Always log errors, even in production
    console.error(...args)
  },
}
